import { Typography } from "@mui/material";
import { version } from "@/../package.json";

const AppBuildInfo = (): React.ReactNode => {
	return <Typography align="center" variant="caption">{`Version: ${version}`}</Typography>;
};

export { AppBuildInfo };
